import { RemoteReporter, logger } from '@tinkoff/logger';
import request from '@tinkoff/request-core';
import http from '@tinkoff/request-plugin-protocol-http';

import { getSentryReporter } from '@breeze/web-lib-sentry';
import { createWuid } from '@breeze/web-lib-wuid';

const collectRequest = request([http()]);

const wuid = createWuid();

const logsReporter = new RemoteReporter({
  emitLevels: {
    error: true,
    fatal: true,
  },
  async makeRequest(logObj) {
    return collectRequest({
      httpMethod: 'POST',
      type: 'json',
      url: import.meta.env.VITE_LOGS_COLLECTOR_HOST,
      payload: {
        appName: 'merchant-dashboard-web',
        wuid,
        ...logObj,
      },
    });
  },
});

logger.setLevel('info');
logger.addReporter(logsReporter);
logger.addReporter(getSentryReporter());

export { logger } from '@tinkoff/logger';
